import React from "react";
import { Spin } from "antd";
import { ErrorServer } from "../../../../components/Errors/ErrorServer";

export const CustomViewSimulation = ({ children, isExistHrsEquivalency = false, error = false, loading = false, name = "" }) => {
    if (loading) {
        return (
            <div className="lg:p-12 p-4 w-full min-h-[calc(100vh-64px)] flex justify-center items-center">
                <Spin size="large" />
            </div>
        );
    }
    if (error) {
        return (
            <div>
                <ErrorServer />
            </div>
        );
    }

    return <div className="flex flex-col gap-6">{children}</div>;
};
